/** Russian for `uz-deals-board.ts`. */
import type { uzDealsBoard } from "./uz-deals-board";

export const ruDealsBoard: Record<keyof typeof uzDealsBoard, string> = {
  "dealsBoard.noPhone": "без номера",
  "dealsBoard.lastMessage": "Последнее сообщение: {time}",
  "dealsBoard.aiMark": "Диалог в режиме AI",
  "dealsBoard.sla.left": "SLA {time}",
  "dealsBoard.sla.overdue": "Просрочено {time}",

  "dealsBoard.refused.conditions": "Условия перехода на этап «{stage}»",
  "dealsBoard.refused.met": "выполнено",
  "dealsBoard.refused.unmet": "не выполнено",
  "dealsBoard.refused.checklistError": "Не удалось получить список условий.",
  "dealsBoard.refused.close": "Закрыть",
  "dealsBoard.refused.open": "Открыть сделку",

  "dealsBoard.destination.label": "Направление",
  "dealsBoard.destination.several": "«{words}» подходит к нескольким направлениям. Выберите одно:",
  "dealsBoard.destination.one": "«{words}» найдено в каталоге. Привязать:",
  "dealsBoard.destination.advice": "нужна консультация",
  "dealsBoard.destination.adviceHint": "«{words}» нет в каталоге. Уточните у клиента, какое место он имеет в виду.",
  "dealsBoard.destination.saveFailed": "Не удалось сохранить направление",
  "dealsBoard.destination.catalogError": "Не удалось получить каталог.",
  "dealsBoard.destination.retry": "Повторить",
};
